import { createIndexSizeError } from '../factories/index-size-error';
export var wrapAudioBufferGetChannelDataMethod = function wrapAudioBufferGetChannelDataMethod(audioBuffer) {
  audioBuffer.getChannelData = function (getChannelData) {
    return function (channel) {
      try {
        return getChannelData.call(audioBuffer, channel);
      } catch (err) {
        if (err.code === 12) {
          throw createIndexSizeError();
        }

        throw err; // tslint:disable-line:rxjs-throw-error
      }
    };
  }(audioBuffer.getChannelData);
};